<template>
    <div class="flex flex-wrap -mx-2">
        <div
            v-for="(item, index) in itemsCurrent"
            :key="item.id"
            class="w-1/2 md:w-1/3 lg:w-1/4 px-2 mb-4"
        >
            <div class="rounded-lg border border-brand-blue overflow-hidden">
                <div class="relative">
                    <img
                        v-if="item.images && item.images.length"
                        v-img:group
                        v-img-loading
                        loading="lazy"
                        :src="item.images[0].url | image"
                        :alt="item.images[0].alt"
                        class="w-full object-cover"
                        style="aspect-ratio: 4/3"
                    />
                    <div
                        v-else
                        class="w-full bg-brand-blue flex items-center justify-center text-white"
                        style="aspect-ratio: 4/3"
                    >
                        Sin imagen
                    </div>
                    <div class="absolute top-2 right-2">
                        <app-button danger icon @click="remove(index)">
                            🗑
                        </app-button>
                    </div>
                    <div class="absolute top-2 left-2">
                        <span
                            class="bg-stack-primary text-white text-xs font-semibold px-2 py-1 rounded-full"
                        >
                            #{{ index + 1 }}
                        </span>
                    </div>
                </div>
                <div class="p-3 bg-brand-blue">
                    <router-link
                        :to="`/app/${entity}/detail/${item.slug}`"
                        class="text-white p-0 font-semibold text-sm block truncate hover:text-gray-400"
                    >
                        {{ item.name }}
                    </router-link>
                    <p class="text-xs text-gray-200 mt-1 truncate">
                        {{ item.slug }}
                    </p>
                    <p
                        v-if="item.summary"
                        class="text-xs text-white mt-1"
                        style="
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            line-clamp: 2;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                        "
                    >
                        {{ item.summary | cut(25) }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { DEFAULT_IMAGE_URL } from "@/common/constants";

export default {
    name: "ItemsCards",
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            type: Array,
            required: true,
            default: () => [
                {
                    id: 72,
                    name: "Item Name",
                    slug: "item-slug",
                    summary: "ShortDescription",
                    images: [
                        {
                            id: 128,
                            url: DEFAULT_IMAGE_URL,
                            alt: "Bota de niño de sapito",
                            sequence: {
                                sequence: 0
                            }
                        }
                    ]
                }
            ]
        },
        entity: {
            type: String,
            default: () => "brands",
            required: false
        }
    },
    emits: ["change"],
    data: () => ({}),
    methods: {
        remove(fromIndex) {
            let items = [...this.itemsCurrent];
            items.splice(fromIndex, 1);
            this.$emit("change", items);
        }
    }
};
</script>
